export default __webpack_public_path__ + "static/media/NTORQ 125_4.79d86c33.webp";